// extracted by mini-css-extract-plugin
export default {"layoutStyle":"CenterBlock_layoutStyle__3niZF","contentStyle":"CenterBlock_contentStyle__H0E67"};